const Style = {
  user: 'absolute top-1/2 -translate-y-2/4 right-10 z-10',
  name: 'float-right text-black text-xs font-normal',
  company: 'float-right text-black text-xs font-normal',
};

export default Style;
